import { useMemo } from 'react';
import {
  SortOptionsWithLabels,
  validSoftPullSortOptions
} from '~/constants/srp/SortOption';
import { useHasSoftPull } from '~/context/srp/FinanceContext/FinanceContext';

export default function useGetAvailableSortOptions() {
  const hasSoftPull = useHasSoftPull();

  return useMemo(
    () =>
      SortOptionsWithLabels.filter(option =>
        validSoftPullSortOptions.includes(option.key) ? hasSoftPull : true
      ),
    [hasSoftPull]
  );
}
